import {HttpClient} from "@angular/common/http";
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {LOGBOOK_API} from "../../app.constants";

@Injectable()
export class SignUp {

    constructor(private http: HttpClient) {
    }

    save(user: any, invitation: string): Observable<any> {
        return this.http.post(`${LOGBOOK_API}/api/sign-up`, {user, invitation});
    }
}
